import { useResource } from '@landsbankinn/l16n';
import { Button } from '@landsbankinn/ui-kit';
import { useApplicationClientContext } from '../../../state';
import { submitAccessDenied } from '../utils';
import { res } from './RejectButton.res';

export function RejectButton(props: { fullwidth: boolean }) {
  const [, clientDispatch] = useApplicationClientContext();
  const { r } = useResource();

  return (
    <Button
      width={props.fullwidth ? '100%' : undefined}
      type="button"
      variant="secondary"
      onClick={() => {
        submitAccessDenied(clientDispatch);
      }}
    >
      {r(res.reject)}
    </Button>
  );
}
